import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import firebase from 'firebase';
import { StorageKeys } from 'src/cometchat-pro-angular-ui-kit/CometChatWorkspace/projects/angular-chat-ui-kit/src/utils/enums';
declare var google: any;
import { AuthService } from './service/auth.service';
import { StorageService } from './service/storage.service';
import { SearchDTO } from './_models/searchdto';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'clinics';
  isLoggedIn: boolean;

  constructor(
    private swUpdate: SwUpdate,
    private cdRef: ChangeDetectorRef,
    private authService: AuthService,
    private storage: StorageService
  ) {
    this.checkUserAuthStatus();
  }

  async ngOnInit() {
    // if new version exists and has been loaded, ask any active user to accept a refresh
    // https://blog.angular-university.io/angular-service-worker/
    
    if (this.swUpdate.isEnabled) {

      this.swUpdate.available.subscribe(() => {

        if (confirm('New version available. Load New Version?')) {

          window.location.reload();
        }
      });
    }

    let responseFromGoogleAPI: any = await this.setCurrentPosition();
    console.log(responseFromGoogleAPI);
  }

  onTopbarLogoutItemClick(event: Event): void {

    this.authService.doLogout()
      .then(res => {
        this.authService.setCurrentUser(null);
        this.isLoggedIn = false;
      }, err => {
      });
    event.preventDefault();
  }

  checkUserAuthStatus(): any {
    firebase.auth().onAuthStateChanged((user: firebase.User) => {
      if (user) {
        this.authService.setCurrentUser(user);
        this.isLoggedIn = true;
      }
      this.cdRef.detectChanges(); // needed because onAuthStateChanged is not triggering angular change detection
    });
  }

  getLocationFromLatLng = (latLng: any) => {
    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: latLng }, (results: any, status: any) => {
        if (status === 'OK') {
          resolve(results[0]);
        } else {
          reject(status);
        }
      });
    });
  };

  private async saveLocation(pos: any) {
    const currentLocation: SearchDTO = {
      lng: +pos.coords.longitude,
      lat: +pos.coords.latitude,
    };
    let location: any = await this.getLocationFromLatLng(currentLocation);
    if (
      location.address_components.filter(
        (x) => x.types.indexOf('postal_code') != -1
      )[0]
    ) {
      currentLocation.zipcode = location.address_components.filter(
        (x) => x.types.indexOf('postal_code') != -1
      )[0].long_name;
    }
    if (
      location.address_components.filter(
        (x) => x.types.indexOf('locality') != -1
      )[0]
    ) {
      currentLocation.city = location.address_components.filter(
        (x) => x.types.indexOf('locality') != -1
      )[0].long_name;
    }
    if (
      location.address_components.filter(
        (x) => x.types.indexOf('administrative_area_level_1') != -1
      )[0]
    ) {
      currentLocation.state = location.address_components.filter(
        (x) => x.types.indexOf('administrative_area_level_1') != -1
      )[0].long_name;
    }
    this.storage.setLocation(currentLocation);
    this.storage.setUserLocation(currentLocation);
  }

  public async setCurrentPosition(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (navigator) {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(
            async (pos: any) => {
              this.storage.SetProperty(StorageKeys.UserAllowedLocation, true);
              await this.saveLocation(pos);
              resolve(true);
            },
            async (Err) => {
              this.storage.SetProperty(StorageKeys.UserAllowedLocation, false);
              resolve(Err.PERMISSION_DENIED);
            }
          );
        }
      }
    });
  }

}
